// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-customer-container {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.create-customer-container h2 {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
  border-bottom: 3px solid #667eea;
  padding-bottom: 10px;
}

.customer-form {
  max-width: 900px;
}

.form-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.form-section h3 {
  color: #555;
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  width: 100%;
  margin-bottom: 15px;
}

.form-group label {
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.form-group input,
.form-group textarea {
  padding: 12px 15px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.alert {
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
}

.alert-error {
  background: #fee;
  color: #c33;
  border-left: 4px solid #c33;
}

.alert-success {
  background: #efe;
  color: #3c3;
  border-left: 4px solid #3c3;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #e0e0e0;
}

.form-actions .btn {
  padding: 14px 40px;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .create-customer-container {
    padding: 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .create-customer-container h2 {
    font-size: 1.5rem;
  }

  .form-section h3 {
    font-size: 1.1rem;
  }

  .form-actions {
    justify-content: stretch;
  }

  .form-actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateCustomer.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".create-customer-container {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.create-customer-container h2 {\n  color: #333;\n  margin-bottom: 25px;\n  font-size: 1.8rem;\n  border-bottom: 3px solid #667eea;\n  padding-bottom: 10px;\n}\n\n.customer-form {\n  max-width: 900px;\n}\n\n.form-section {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #667eea;\n}\n\n.form-section h3 {\n  color: #555;\n  margin-bottom: 20px;\n  font-size: 1.2rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 15px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #555;\n  margin-bottom: 8px;\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group textarea {\n  padding: 12px 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.alert {\n  padding: 15px 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.alert-error {\n  background: #fee;\n  color: #c33;\n  border-left: 4px solid #c33;\n}\n\n.alert-success {\n  background: #efe;\n  color: #3c3;\n  border-left: 4px solid #3c3;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 2px solid #e0e0e0;\n}\n\n.form-actions .btn {\n  padding: 14px 40px;\n  font-size: 1.1rem;\n}\n\n@media (max-width: 768px) {\n  .create-customer-container {\n    padding: 20px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .create-customer-container h2 {\n    font-size: 1.5rem;\n  }\n\n  .form-section h3 {\n    font-size: 1.1rem;\n  }\n\n  .form-actions {\n    justify-content: stretch;\n  }\n\n  .form-actions .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
